import { useParams } from 'react-router-dom';
import { CalendarInactiveIcon } from '../../../../../assets/images/components';
import { IorganizationBusinessData } from '../../../../../types/bussines';
import { formatShortDate } from '../../../../../utils/formatDatesAndHours';
import { truncateText } from '../../../../../utils/truncateText';
import { CopyIcon } from '../../../../../assets/images';
import './OrgDetailsHeader.scss';

interface ITab {
  id: number;
  name: string;
}

const OrgDetailsHeader = ({
  organizationData,
  optionsTabs,
  selectTab,
  changeTab
}: {
  organizationData: IorganizationBusinessData;
  optionsTabs: ITab[];
  selectTab: ITab;
  changeTab: (e: ITab) => void;
}) => {
  const { organizationId } = useParams<{ organizationId: string }>();

  const organizationUuidText = organizationData?.uuid || 'Sin datos';
  const copyUuid = async () => await navigator.clipboard.writeText(organizationData?.uuid || '');

  const getOrganizationStatus = () => {
    if (organizationData?.statusName === 'active') return 'Aprobado';
    if (organizationData?.statusName === 'pending') return 'Sin aprobar';
    if (organizationData?.statusName === 'rejected') return 'No aprobado';
  };

  return (
    <div className="orgDetailsHeader" style={{ paddingBottom: selectTab.id !== 1 ? '0px' : '' }}>
      <section className="leftSection">
        <div className="nameAndId">
          {organizationData?.name && <div className="organizationName">{truncateText(organizationData.name, 120)}</div>}
          <div className="organizationId">ID: {organizationId}</div>
          <div className="organizationUuid">
            <div className="title">ID Facturación: </div>
            <div className="text">{organizationUuidText}</div>
            {organizationData?.uuid && <CopyIcon className="copyIcon" onClick={copyUuid} />}
          </div>
        </div>
        <div className="tabsContainer">
          {optionsTabs &&
            optionsTabs.length > 0 &&
            optionsTabs.map(item => {
              return (
                <div
                  key={`key-id-tab-${item.id}`}
                  onClick={() => {
                    if (selectTab.id !== item.id) {
                      changeTab(item);
                    }
                  }}
                  className={`tab generalTab ${selectTab.id !== item.id ? 'noSelectTab' : ''}`}
                >
                  {item.name}
                </div>
              );
            })}
        </div>
      </section>
      <section className="rightSection">
        <div className={`organizationState ${organizationData?.statusName ? organizationData?.statusName : ''}`}>
          {getOrganizationStatus()}
        </div>
        <div className="registrationDateContainer">
          <label className="label disabled">Fecha de registro</label>
          <div className="registrationDate">
            {organizationData?.creationDate
              ? formatShortDate(organizationData.creationDate)?.textWithTimezone
              : 'Dato incompleto'}
            <img src={CalendarInactiveIcon} alt="Calendario" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default OrgDetailsHeader;
